var _defs, _path, _g, _rect, _line;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReEngineering(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "design",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffd546;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:none;stroke:#333;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 20.6,
    y1: 18.42,
    x2: 20.6,
    y2: 12.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#ffd545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#ffde6d",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#fff5d1",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#fffef9",
    stopOpacity: 0
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.31,35.94H22.8a2.32,2.32,0,0,1,2.31,2.31V42H1V38.25A2.31,2.31,0,0,1,3.31,35.94Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "construction_site",
    "data-name": "construction site"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1 18.42 40.19 18.42 35.84 12.32 6.23 12.32 1 18.42"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 40.19,
    y1: 55,
    x2: 40.19,
    y2: 19.29
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "46.29 11.45 46.29 9.71 55 9.71 55 18.42 47.16 18.42 47.16 55"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 40.19,
    y1: 1,
    x2: 40.19,
    y2: 11.45
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1 18.42 40.19 18.42 35.84 12.32 6.23 12.32 1 18.42"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "20.16 12.32 40.19 1 55 9.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M9.61,28.87a2.62,2.62,0,1,0,3.61-2.41,1.69,1.69,0,0,1-1-1.58V18.42"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1,
    y: 35.94,
    width: 24.11,
    height: 19.06,
    rx: 2.31
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 4.45,
    y1: 39.32,
    x2: 7.29,
    y2: 39.32
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReEngineering);
export default __webpack_public_path__ + "static/media/re-engineering.bd23b3bc83ee957a22ebadfb6025c3e2.svg";
export { ForwardRef as ReactComponent };